<template>
	<el-dialog title="新增保养记录" v-model="isAddRecord" width="60%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<!-- <p class="platTitle">基础信息</p> -->
			<div class="info-input-container">
				<div class="flex flex-y-start flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>车牌号码</span>
						</div>
						<el-input v-model="vemrVehNo" class="platItemRigth" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">

					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养日期</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="vemrUpdateDate" type="datetime" :clearable="false"
								placeholder="请选择保养日期" @change="getvemrUpdateDate">
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养时里程</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="vemrUpdateMiles" placeholder="" />
							<div class="link-box">
								<i class="el-icon-link"></i>公里
							</div>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养标题</span>
						</div>
						<el-input v-model="vemrTitle" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养费用</span>
						</div>
						<div class="input_box flex" style="background: #fff; border: 1px solid #dcdfe6">
							<input type="text"
								style="border: none;outline: none;flex: 1;padding-left: 10px;height: 30px;color: #606266;"
								v-model="vemrMoney" placeholder="" />
							<div class="link-box">
								<i class="el-icon-link"></i>元
							</div>
						</div>
					</div>
					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>保养信息</span>
						</div>
						<el-input v-model="vemrDescribe" type="textarea" class="platItemRigth2" placeholder="请输入"
							:rows="5" />
					</div>

					<div class="w100 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span>保养凭证</span>
						</div>
						<div class="rpic_img_box">
							<template v-if="vemrProofUrl.length > 0">
								<div class="upRpic_icon_item" v-for="(item, index) in vemrProofUrl" :key="index">
									<img :src="item" alt="" style="width: auto; height: 60%" />
									<div class="image-box-item-del" @click="delImg(index)">
										<img src="@/assets/images/handle/del-icon.png" alt="" />
									</div>
								</div>
							</template>

							<el-upload :show-file-list="false" :auto-upload="false" :multiple="false"
								:on-change="uploadvemrProofUrl" accept=".jpg,.jpeg,.png" v-if="vemrProofUrl.length < 6">
								<div class="upRpic_icon_item">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
									<span class="fontSize14 col-999">上传图片</span>
								</div>
							</el-upload>
						</div>
					</div>
				</div>
			</div>

			<div class="flex flex-y-center flex-wrap">
				<p class="platTitle">保养项目列表</p>
				<img v-if="vemrItemsList.length == 0" src="@/assets/images/add-goods-icon.png" @click="addJy()" alt=""
					srcset="" style="margin: 0 10px;cursor: pointer;" />
			</div>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="jzWrap">
						<div class="jzBox flex flex-y-center" v-for="(item, index) in vemrItemsList" :key="index">
							<div class="flex flex-y-center flex-wrap jzBoxLeft"
								style="padding-right: 20px;padding-left: 20px;">
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<p style="color: #000;font-weight: 500;padding-right: 10px;">{{index+1}}</p>
										<span class="input-fail">*</span>
										<span>项目类型:</span>
									</div>
									<div class="flex platItemRigth flex-y-center">
										<!-- <el-select v-model="item.vemiType" filterable allow-create default-first-option
											placeholder="请选择项目类型">
											<el-option label="打黄油" value="打黄油" />
											<el-option label="机油" value="机油" />
										</el-select> -->

										<el-select v-model="item.vemiType" ref="produceRef" clearable filterable
											placeholder="请选择项目类型" @blur="(event) => handleBlur(event, index)"
											allow-create>
											<el-option label="打黄油" value="打黄油"> </el-option>
											<el-option label="换机油" value="换机油"> </el-option>
											<el-option label="防冻液" value="防冻液"> </el-option>
											<el-option label="首保" value="首保"> </el-option>
											<el-option label="二级维护" value="二级维护"> </el-option>
											<el-option label="特种设备检验" value="特种设备检验"> </el-option>
										</el-select>

									</div>
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>项目名称:</span>
									</div>
									<el-input v-model="item.vemiName" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span>品牌:</span>
									</div>
									<el-input v-model="item.vemiBrand" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span>规格:</span>
									</div>
									<el-input v-model="item.vemiSpecifications" class="platItemRigth"
										placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span>单价:</span>
									</div>
									<el-input v-model="item.vemiPrice" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span>数量:</span>
									</div>
									<el-input v-model="item.vemiCount" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span>总价:</span>
									</div>
									<el-input v-model="item.vemiPriceSum" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span>备注:</span>
									</div>
									<el-input v-model="item.vemiRemark" class="platItemRigth" placeholder="请输入" />
								</div>

							</div>
							<div class="jzBoxRight flex flex-y-center" v-if="pageType != 'detail'">
								<img src="@/assets/images/add-goods-icon.png" @click="addJy()" alt="" srcset="" />
								<img src="@/assets/images/del-goods-icon.png" @click="delJy(index)" alt="" srcset="" />
							</div>
						</div>
					</div>
				</div>
			</div>


			<div class="footer_btn_warp">
				<template v-if="pageType != 'detail'">
					<div class="cancle_btn" v-on:click="closeModal()">取消</div>
					<div class="confirm_btn" v-on:click="submit()">确定</div>
				</template>
				<template v-else>
					<div class="cancle_btn" v-on:click="closeModal()">关闭</div>
				</template>
			</div>

		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		ref,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		parseTime,
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	// import Address from "./address";
	export default defineComponent({
		components: {
			// Address
		},
		name: "AddRecord",
		props: {
			sendData: {
				type: Object,
			},
		},
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {
					getVehicleList(); //获取车辆
					//getProvinceList(); //获取省份
					//getProviderList(); //获取客商
				});
			});
			const data = reactive({
				isAddRecord: false,
				provinceList: [], //省
				cityList: [], //市
				areaList: [], //区县
				ProviderList: [], //所属客商
				vehHeadList: [],
				lorVehicleId: null, //运力车辆
				isAddress: false,
				addType: "",

				vemrVehId: "",
				vemrVehNo: "",
				vemrType: "1",
				vemrUpdateDate: "",
				vemrUpdateMiles: "",
				vemrTitle: "",
				vemrMoney: "",
				vemrDescribe: "",
				vemrRemark: "",
				vemrProofUrl: [], //凭证图片
				vemrItemsList: [{
					vemiType: "",
					vemiName: "",
					vemiBrand: "",
					vemiSpecifications: "",
					vemiPrice: 0,
					vemiCount: 0,
					vemiPriceSum: 0,
					vemiRemark: ""
				}],
			});
			//重置数据
			const init = (id, vehNo) => {
				data.isAddRecord = true;
				data.vemrVehId = id;
				data.vemrVehNo = vehNo;
				data.vemrType = "1";
				data.vemrUpdateDate = "";
				data.vemrUpdateMiles = "";
				data.vemrTitle = "";
				data.vemrMoney = "";
				data.vemrDescribe = "";
				data.vemrRemark = "";
				data.vemrProofUrl = [];
				data.vemrItemsList = [{
					vemiType: "",
					vemiName: "",
					vemiBrand: "",
					vemiSpecifications: "",
					vemiPrice: 0,
					vemiCount: 0,
					vemiPriceSum: 0,
					vemiRemark: ""
				}];

				data.addType = "";
				data.vehHeadList = [];
				data.lorVehicleId = null; //运力车辆
			};

			const dialogClosedHandle = () => {
				data.isAddRecord = false;
			};

			const closeModal = () => {
				data.isAddRecord = false;
			};

			const submit = async () => {
				if (data.vemrVehId == "") {
					proxy.$message.error("请填写车辆");
					return;
				}
				if (data.vemrUpdateDate == "") {
					proxy.$message.error("请填写保养时时间");
					return;
				}
				if (data.vemrUpdateMiles == "") {
					proxy.$message.error("请填写保养时里程");
					return;
				}
				if (data.vemrTitle == "") {
					proxy.$message.error("请填写保养标题");
					return;
				}
				if (data.vemrMoney == "") {
					proxy.$message.error("请填写保养金额");
					return;
				}
				if (data.vemrDescribe == "") {
					proxy.$message.error("请填写保养项目");
					return;
				}
				if (data.vemrItemsList.length <= 0) {
					proxy.$message.error("请添加保养项目列表");
					return;
				}

				const index = data.vemrItemsList.findIndex(item => item.vemiType === "" || item
					.vemiName === "")
				if (index !== -1) {
					proxy.$message.error("请正确填写保养项目列表");
					return;
				}

				// data.vemrItemsList.forEach((el) => {
				// 	if (el.vemiType === "" || el.vemiName === "") {
				// 		proxy.$message.error("请正确填写保养项目列表");
				// 		return;
				// 	}
				// });


				let params = {
					vemrVehId: data.vemrVehId,
					vemrType: data.vemrType,
					vemrUpdateDate: data.vemrUpdateDate,
					vemrUpdateMiles: data.vemrUpdateMiles,
					vemrTitle: data.vemrTitle,
					vemrMoney: data.vemrMoney,
					vemrDescribe: data.vemrDescribe,
					vemrRemark: data.vemrRemark,
					proofPicList: data.vemrProofUrl,
					itemList: data.vemrItemsList,
				}

				const r = await proxy.$http.post(apiObj.vehMaintenanceRecsave, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();

					data.isAddRecord = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};
			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};

			//选择运力车辆
			const getVehicleList = async () => {
				let params = {
					searchWord: "",
					page: 1,
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.vehicleList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.rows;
				}
			};

			//获取所属客商
			const getProviderList = async () => {
				let params = {
					page: 1,
					limit: 10000,
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.ProviderList = res.rows;
				}
			};

			const getvemrUpdateDate = (ev) => {
				data.vemrUpdateDate = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.vemrUpdateDate);
			};

			//删除图片
			const delImg = (index) => {
				let url = data.vemrProofUrl[index];
				if (url.indexOf("https://") !== -1) {
					removeImgUrl(url);
				}
				data.vemrProofUrl.splice(index, 1);
			};

			//上传图片
			const upLoadBase64uploadToOSS = async (imageUrl, type) => {
				await proxy.$http.post("/api/ossUpload/base64Json", {
						name: imageUrl,
						value: "123",
					})
					.then((res) => {
						// if(res.)
						data[type] = res;
					});
			};

			const uploadvemrProofUrl = (file) => {
				const isLt2M = file.raw.size / 1024 / 1024 < 2;
				if (isLt2M == false) {
					proxy.$message.error("请上传小于2M的图片");
					return;
				}
				imgFileToBase64(file, (imageUrl) => {
					if (data.vemrProofUrl.length >= 5) {
						proxy.$message.error("最多上传5张");
						return false;
					}
					proxy.$http
						.post("/api/ossUpload/base64Json", {
							name: imageUrl,
							value: "123",
						})
						.then((res) => {
							data.vemrProofUrl.push(res);
						});
				});
			};

			//删除图片
			const removeImgUrl = async (imageUrl) => {
				await proxy.$http.post("/biz/bdzl/rptInfo/removeUrl", {
						url: imageUrl
					})
					.then((res) => {});
			};

			const delJy = (index) => {
				proxy.$confirm("您确定删除吗?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					data.vemrItemsList.splice(index, 1);
				});
			};

			const addJy = () => {
				// var specDefault = false;
				// if (this.vemrItemsList.length <= 0) {
				// 	specDefault = true;
				// } else {
				// 	this.vemrItemsList.forEach((el) => {
				// 		if (el.specDefault) {
				// 			specDefault = false;
				// 		}
				// 	});
				// }
				data.vemrItemsList.push({
					vemiType: "",
					vemiName: "",
					vemiBrand: "",
					vemiSpecifications: "",
					vemiPrice: 0,
					vemiCount: 0,
					vemiPriceSum: 0,
					vemiRemark: ""
				});
			};

			const handleBlur = (event, index) => {
				let value = event.target.value; // 输入框值
				if (value) { // 只有输入才有这个值，下拉框选择的话 这个值为空
					data.vemrItemsList[index].vemiType = value
				}

				//data.vemrItemsList[index].vemiType = proxy.$refs.produceRef.selectedLabel
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit,
				uniqueArr,
				getvemrUpdateDate,
				delImg,
				uploadvemrProofUrl,
				delJy,
				addJy,
				handleBlur,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}



	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 90px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth2 {
		width: 90%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.input_box {
		margin-left: 20px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 77%;
		height: 35px;
		padding-left: 0px;
	}

	.link-box {
		margin-right: 10px;
		font-size: 14px;
		color: #606266;
		cursor: pointer;
		width: 60px;
		text-align: right;
	}

	.rpic_img_box {
		width: 100%;
		height: 170px;
		border: 1px solid #eeeeee;
		border-radius: 4px;
		margin-left: 20px;
		margin-right: 20px;
		display: flex;
		flex-wrap: wrap;
	}

	.upRpic_icon_item {
		margin-top: 20px;
		width: 125px;
		height: 125px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic_icon {
		width: 20px;
		height: 20px;
	}

	.jzBox {
		border: 1px solid #e6e6e6;
		width: fit-content;
		height: 250px;
		font-size: 14px;
		margin-left: 50px;
		border-top: none;
	}

	.jzWrap .jzBox:nth-child(1) {
		border-top: 1px solid #e6e6e6;
	}

	.jzBoxLeft .jzTitle {
		min-width: 100px;
		text-align: center;
		margin: 0 30px;
		display: block;
	}

	.jzBoxLeft .shu {
		display: block;
		width: 1px;
		height: 20px;
		background: #e1e1e1;
		margin: 0 0px 0 60px;
	}

	.jzBoxRight {
		padding-left: 10px;
		margin-left: 20px;
		height: 200px;
		border-left: 1px solid #e6e6e6;
	}

	.jzBoxRight img {
		margin: 0 10px;
		cursor: pointer;
	}
</style>